export default {
  最新采购商机: 'Latest Purchasing Opportunities',
  恭喜: 'Congratulation',
  成为了: 'became',
  发布的: 'posted in',
  采购需求的供应商: 'suppliers with purchasing needs',

  发布我的采购需求: 'Post My Purchase Request',
  产品名称: 'Product name',
  产品名称不能为空: 'Product name cannot be empty',
  产品名称不能超过60个字符: 'Product name cannot exceed 60 characters',
  请输入采购产品名称: 'Please enter the name of the purchased product',
  请输入的手机号: 'Please enter the cell phone number',
  请输入正确格式的手机号: 'Please enter the correct format of cell phone number',
  发布我的采购需求提示1:
    '*If the cell phone number is not registered, the system will automatically register and login by default',
  发布我的采购需求提示2: 'Recommend the buyers to quality suppliers.',
  其他补充要求: 'Other Supplementary Requirements',
  '上传附件/设置采购总金额': 'Upload Attachments/Set the Purchase Amount',
  发布成功: 'Publish successfully',

  采购地区: 'Purchasing area',
  排序: 'Sort',
  设置排序: 'Set Sort',
  加入标签: 'Add Label',
  时间排序: 'Release Time',
  正序: 'preface',
  倒序: 'reverse order',
  无标题: 'No title',
  采购类型: 'Purchase Type',
  预估采购金额: 'Estimated Amount',
  收货地区: 'Collection area',
  具体洽谈: 'Specific negotiation',
  全球: 'Global',
  全国: 'National（China）',
  长期有效: 'Long-term validity',
  距离报价结束: 'From the end',
  还剩: 'Remaining',
  已采购: 'Purchased',
  立即报价: 'Quote Now',
  已有: 'Already have',
  人报价: 'People Quote',
  采购描述: 'Purchase Description',
  附件: 'Annexes',
  被Ta选中的供应商: 'Suppliers selected by Ta',
  更多云采购推荐: 'More cloud procurement recommendations',
  暂无推荐: 'No recommendation',
  采购详情提示1:
    'Individual users cannot initiate cloud procurement cooperation, please apply to become an enterprise first and then try again!',
  采购详情提示2: 'Cannot negotiate with yourself!',
  个人用户暂时无法洽谈: 'Individual users are temporarily unable to negotiate',
  请登录: 'Please login',

  会员中心云采购详情提示1: "You can't restore it after you take it down, are you sure you want to take it down?",
  完成采购: 'End procurement',
  采购编号: 'Purchase number',
  活动状态: 'Status',
  永久: 'Permanent',
  天后过期: 'days expires',
  类别: 'Category',
  具体描述: 'Specific description',
  热门供应商: 'Popular suppliers',
  换一批: 'Change batch',
  暂无热门供应商: 'No popular suppliers',
  我的候选供应商: 'My candidate suppliers',
  预选为供应商: 'Pre-selected as a supplier',
  洽谈: 'Negotiation',
  周: 'Week',
  月: 'Month',
  采购中: 'In Procurement',
  自主下架: 'Autonomous downgrading',
  平台下架: 'Platform downgrades',
  供应商: 'Suppliers',
  剩余有效期: 'Remaining validity',
  供: 'Suppliers',
  采: 'Buyer',
  类型: 'Type',
  系统推荐: 'System recommendation',
  主动联系: 'Proactive Contact',
  是否候选为供应商: 'Whether candidate for supplier',
  已选预为供应商: 'Pre-selected as supplier',
  采购完成: 'Procurement completed',
  下架成功: 'Downgraded successfully',
  请从以下您未选中的供应商作为最终的预备采购企业:
    'Please use the following suppliers, which you have not selected, as the final preparatory purchasing companies',
  跳过不选择: 'Skip, no selection',
  选中成功: 'Selected Success',
  正在提交数据请稍等: 'Please wait while data is submitted',
  确认提示: 'Confirmation Tips',
  采购组件确认提示1:
    'You have not selected any company as a supplier for this purchase, are you sure you want to complete this purchase?',
  已选为供应商: 'Selected as supplier',
  选为供应商: 'Select supplier',
  采购组件确认提示2: 'This company has already been selected as a supplier, no need to repeat the selection!',
  报价: 'Quotation',
  求: 'Request',
  暂无描述: 'No description',
  剩余时间: 'Remaining time',
  暂无类型: 'No type',
  采购提示1: 'Individual users cannot browse cloud procurement information, please apply to become a corporate user!',
  采购提示2:
    'If you want to view more cloud procurement information, please upgrade your corporate membership package.',
}
